import Vue from 'vue'
/* 引入组件 */
import Tabbar from  './Tabbar'
import Header from  './common/Header.vue'
import PageHeader from  './common/PageHeader.vue'
import PageInput from  './common/PageInput.vue'
import PageInputTel from  './common/PageInputTel.vue'
import Empty from  './common/Empty.vue'
import ImagePic from './ImagePic'
import NavBar from './NavBar'

// 注册一些常用的组件到全局
Vue.component('image-pic', ImagePic)
Vue.component('nav-bar', NavBar)
Vue.component('tabbar', Tabbar)
Vue.component('app-header', Header)
Vue.component('page-header', PageHeader)
Vue.component('page-input', PageInput)
Vue.component('page-input-tel', PageInputTel)
Vue.component('empty', Empty)



// WEBPACK FOOTER //
// ./src/components/common.js